export default [
    {
        path: '/mytask',
        component: resolve => require(['../page/mytask/mytask/index.vue'], resolve)
    },

]



// WEBPACK FOOTER //
// ./src/router/dashboard.js